import React from 'react';
import styled from '@emotion/styled';
import { Column, Flex } from '@3pc/layout-components-react';
import { colors } from '../styles/colors';
import { devices } from '../styles/breakpoints';
import { Link } from 'gatsby';
import { Box } from '@3pc/layout-components-react';
import ShareButton from '../base/ShareButton';
import BookmarkButton from '../base/BookmarkButton';

const DetailHeader = styled.header`
  text-align: center;
  margin: -17.5% auto 10px auto;
  width: calc(100% - 40px);
  max-width: 470px;
  background: ${colors.white};
  padding: 17px 10px 10px 10px;
  border-radius: 4px;
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    left: -1px;
    top: -1px;
    width: calc(100% + 2px);
    height: 100%;
    background: linear-gradient(180deg, ${colors.blue} 0%, ${colors.white} 90%);
    border-radius: 4px;
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    left: 1px;
    top: 1px;
    width: calc(100% - 2px);
    height: 100%;
    background: ${colors.white};
    border-radius: 3px;
    z-index: -1;
  }

  @media ${devices.mobileMin} {
    margin-top: -5.5%;
  }

  @media ${devices.tabletMin} {
    padding: 20px;
  }

  p,
  .references li {
    font-style: italic;

    a {
      color: ${colors.blue};
      font-weight: 400;
      display: inline-block;
      padding: 3px;
      border-radius: 4px;
      transition: all 200ms ease-in-out;

      @media ${devices.nonTouchable} {
        &:hover {
          font-weight: 600;
        }
      }

      &:active {
        font-weight: 600;
      }

      &:focus-visible {
        box-shadow: 0 0 2px 3px ${colors['blue-rgba-three']};
        font-weight: 600;
      }

      &:focus {
        outline: 0;
      }
    }
  }
`;

const PageTitle = styled.h1`
  margin-bottom: 17px;
  font-size: 1.25em;
  line-height: 1.25em;

  @media ${devices.mobileMin} {
    font-size: 1.875em;
    line-height: 1.4em;
  }

  @media ${devices.tabletMin} {
    margin-bottom: 7px;
  } ;
`;

const PageSubtitle = styled.h2`
  font-style: italic;
  line-height: 1.313em;
  font-weight: normal;

  @media ${devices.tabletMin} {
    line-height: 1.563em;
  } ;
`;

const DetailPageHeader = ({ headerTitle, headerInfo, pageType, slug }) => {
  return (
    <DetailHeader>
      <PageTitle>{headerTitle}</PageTitle>
      {headerInfo &&
        (pageType === 'detail-page' ? (
          <PageSubtitle>{headerInfo}</PageSubtitle>
        ) : headerInfo.references !== '' ? (
          <>
            <p>Siehe auch:</p>
            <Box as="ol" className="references">
              {headerInfo.references.map((referenceItem, index) => (
                <Box as="li" key={referenceItem}>
                  <Link to={`/lexikon/${headerInfo.urls[index]}`}>
                    {referenceItem}
                  </Link>
                </Box>
              ))}
            </Box>
          </>
        ) : (
          ''
        ))}
      <Column maxWidth="20%">
        <Flex
          justifyContent="space-around"
          alignItems="center"
          marginTop="20px"
        >
          <ShareButton title={headerTitle} />
          <BookmarkButton title={headerTitle} slug={slug} />
        </Flex>
      </Column>
    </DetailHeader>
  );
};

export default DetailPageHeader;
